import axios from "axios";
import { toast } from "react-toastify";
export const BASE_URL = "https://api.bookinclass.co.uk/api/";
//const BASE_URL = "http://localhost:4060/api/";
//const BASE_URL = "http://185.151.29.175:3000/api/";
const LoginUrl = `${window.location.protocol}//${window.location.hostname}/`;
//const LoginUrl = "http://localhost:300";

export const postFormDataNoToken = async (url = "", data = {}) => {
  try {
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL + url, formData);
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};
export const postFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL + url, formData, {
      headers: { token: token ? token : "" },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};
export const patchFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.patch(BASE_URL + url, formData, {
      headers: { token: token ? token : "" },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};
export const postRawData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const response = await axios.post(BASE_URL + url, data, {
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

export const postDataNoBody = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const response = await axios.post(BASE_URL + url, null, {
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

export const getDataNoToken = async (url = "", data = {}) => {
  try {
    const response = await axios.get(BASE_URL + url, {
      params: data,
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const getDataforUrl = async (url = "", data = "") => {
  try {
    const token = await localStorage.getItem("token_u");
    const response = await axios.get(BASE_URL + url + `/${data}`, {
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const getData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const response = await axios.get(BASE_URL + url, {
      params: data,
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    
    toast.error(error.message);
    return null;
  }
};

export const getDataAdmin = async (url = "", data = {}) => {
  try {
    const response = await axios.get(BASE_URL + url, {
      params: data,
      headers: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZG1pbklkIjoxLCJpc0FkbWluIjp0cnVlLCJ1c2VyX3R5cGUiOiJhZG1pbiIsInZlcmlmaWVkIjp0cnVlLCJpYXQiOjE2NjM1ODE5NDUsImV4cCI6MTY2NjE3Mzk0NX0.h6AbA-iHUdDsHqR4roZpo6Wz_pxMHRyLTobWQ1Lao9w",
      },
    });

    return response.data;
  } catch (error) {
    return null;
  }
};

export const getDataStringify = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");

    const response = await axios.get(BASE_URL + url, {
      params: data,

      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const putFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.put(BASE_URL + url, formData, {
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const deleteData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("token_u");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.delete(BASE_URL + url, {
      headers: {
        token: token ? token : "",
      },
      data: formData,
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
    return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const checkTcAcceptance = async (company_id) => {
  try {
    const token = await localStorage.getItem("token_u");
    const response = await axios.get(BASE_URL + "user/checkTcAcceptance", {
      params: { company_id },
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

export const acceptTc = async (company_id, tc_version) => {
  try {
    const token = await localStorage.getItem("token_u");
    const response = await axios.post(BASE_URL + "user/acceptTc", { company_id, tc_version }, {
      headers: {
        token: token ? token : "",
      },
    });
    if(response.data.code == 401){
      localStorage.removeItem("token_u");
      localStorage.removeItem("isModalShow");
      toast.error(response.data.message);
      window.location.href = `${LoginUrl}?message=${response.data.message}`;
      return null;
    }else{
      return response.data;
    }
  } catch (error) {
    toast.error(error.message);
    return null;
  }
};

